import React from "react";
import PropTypes from "prop-types";

const ListViewIcon = ({
  width,
  size,
  height,
  style,
  color = "#57595D",
  noPointer,
  title,
  ...props
}) => {
  return (
    <svg
      {...props}
      style={style}
      data-no-pointer={noPointer}
      width={width || size || 24}
      height={height || size || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
    >
      {title && <title>{title}</title>}
      <g fill="none" fillRule="evenodd">
        <path d="M2 0h18a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" />
        <g transform="translate(4 4)">
          <path d="M0 0h16v16H0z" />
          <rect fill={color} x="1" y="1" width="2" height="2" rx=".5" />
          <rect fill={color} x="5" y="1" width="10" height="2" rx=".5" />
          <rect fill={color} x="1" y="5" width="2" height="2" rx=".5" />
          <rect fill={color} x="5" y="5" width="10" height="2" rx=".5" />
          <rect fill={color} x="1" y="9" width="2" height="2" rx=".5" />
          <rect fill={color} x="5" y="9" width="10" height="2" rx=".5" />
          <rect fill={color} x="1" y="13" width="2" height="2" rx=".5" />
          <rect fill={color} x="5" y="13" width="10" height="2" rx=".5" />
        </g>
      </g>
    </svg>
  );
};

ListViewIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  color: PropTypes.string,
  noPointer: PropTypes.bool,
  title: PropTypes.string
};

export default ListViewIcon;
